import { get } from "lodash";

export interface FileDocument {
  id?: string;
  folderName: string;
  fileName?: string;
  originalFileName: string;
  chunkIndex?: number;
  totalChunk?: number;
  isChunked: boolean;
}

export const buildFileDocumentCustomFormData = (
  data: any
): {
  [key: string]: Object;
}[] => {
  return Object.keys(data).map((key) => ({ [key]: get(data, key) })) as {
    [key: string]: Object;
  }[];
};
